import moment from 'moment';
import { fileDownload } from '../../../../../common/services/fileUtils';
import { EDGE_ACTIVITIES_EXPORT_HEADERS } from '../const/common';
import { LLLFormat } from '../../../../../common/services/ValidationRules';

const FILE_NAME = 'edge-activities.csv';
const FILE_TYPE = 'text/csv;charset=utf-8;';

const formatTimestamp = (value) => (value ? moment.utc(value).format(LLLFormat) : '');

export const buildActivitiesCsv = (rows, { items, selectAll }) => {
  const selectedIds = new Set(items || []);
  const exportRows = selectAll ? rows : rows.filter((row) => selectedIds.has(row.uuid));

  return [
    EDGE_ACTIVITIES_EXPORT_HEADERS.join(','),
    ...exportRows.map((row) =>
      [formatTimestamp(row.timestamp), row.user_name, row.origin, row.field, row.old_value ?? '', row.new_value ?? '']
        .map((value) => `"${String(value ?? '').replaceAll('"', '""')}"`)
        .join(','),
    ),
  ].join('\n');
};

export const downloadActivitiesCsv = (rows, exportParams) => {
  const csv = buildActivitiesCsv(rows, exportParams);

  fileDownload(csv, FILE_NAME, FILE_TYPE);
};
